import { CatalogueProductOption } from 'types/bundleProduct'

export const getProductDisplayName = (product?: CatalogueProductOption) =>
  product?.onlineDesc || product?.description || 'Unknown product'

export const getProductPackInfo = (product?: CatalogueProductOption) =>
  product?.uomPackagingInfo || product?.uom || null
